module.exports = __webpack_public_path__ + "img/chickenburger.cab0b42c.jpg";